import { Box } from 'hephaestus/web';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

const LEADING_OR_TRAILING_BLANK_LINES = /^(?:[ \t]*\n)+|(?:\n[ \t]*)+$/g;
const EXTRA_BLANK_LINES = /\n(?:[ \t]*\n){2,}/g;
const FENCED_CODE = /^ {0,3}(?:```|~~~)/m;

// Markdown collapses any run of blank lines into one paragraph break, so each
// blank line past the first becomes a non-breaking-space paragraph. Fenced code
// is left alone because it already keeps its blank lines.
const keepExtraBlankLines = (markdown: string) => {
  const text = markdown
    .replace(/\r\n?/g, '\n')
    .replace(LEADING_OR_TRAILING_BLANK_LINES, '');
  if (FENCED_CODE.test(text)) return text;
  return text.replace(EXTRA_BLANK_LINES, (run) => {
    const blankLineCount = run.split('\n').length - 2;
    return `\n\n${'\u00A0\n\n'.repeat(blankLineCount - 1)}`;
  });
};

export type MarkdownTextProp = {
  children: string;
};

export const MarkdownText = ({ children }: MarkdownTextProp) => (
  <Box
    sx={{
      '& p': { m: 0 },
      '& p:not(:first-child)': { mt: 1.5 },
      '& table': { width: '100%' },
      '& img': { maxWidth: '100%' },
    }}
  >
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkBreaks]}
      linkTarget='_blank'
    >
      {keepExtraBlankLines(children)}
    </ReactMarkdown>
  </Box>
);
